module.exports = __webpack_public_path__ + "img/worm-attack-02.747f02f1.png";